import { render, staticRenderFns } from "./SaisaAnnualMarksheet.vue?vue&type=template&id=5c792d87&scoped=true&"
import script from "./SaisaAnnualMarksheet.vue?vue&type=script&lang=js&"
export * from "./SaisaAnnualMarksheet.vue?vue&type=script&lang=js&"
import style0 from "./SaisaAnnualMarksheet.vue?vue&type=style&index=0&id=5c792d87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c792d87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOverlay,VProgressCircular,VSnackbar})
